import {lineItemsDoingDragDrop} from '../constants';

export const lineItemsDragDropReducer = (previousState = false, {type, payload}) => {
    if (type === lineItemsDoingDragDrop) {
        return payload;
    }

    return previousState;
};